import create from 'zustand'

interface ShowFloatingOrgSidebarState {
  showFloatingOrgSidebar: boolean
  setShowFloatingOrgSidebar: (show: boolean) => void
}

export const useShowFloatingOrgSidebar = create<ShowFloatingOrgSidebarState>((set) => ({
  showFloatingOrgSidebar: false,
  setShowFloatingOrgSidebar: (show) => set({ showFloatingOrgSidebar: show }),
}))
